import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwBadgeNotification, CwIcon, CwTooltip } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { Status } from '~/app/constants/AppStatuses';
import { IconCloudLoadingComponent } from '~/app/custom-icons/icon-cloud-loading/icon-cloud-loading.component';
import { IconCloudSyncComponent } from '~/app/custom-icons/icon-cloud-sync/icon-cloud-sync.component';
import { ConnectionType } from '~/app/enums/ConnectionType';
import { DateFormat } from '~/app/enums/DateFormat';
import { LocalizedDatePipe } from '~/app/pipes/LocalizedDate';
import { HeaderService } from '~/app/services/header.service';
import { NetworkService } from '~/app/services/network.service';
import { SidebarIds, SidebarService } from '~/app/services/sidebar.service';
import { StatusService } from '~/app/services/status.service';
import { WsEventsService } from '~/app/services/websocket.service';
import { TherapyJobStore } from '~/app/store/job.store';
import { NotificationsStore } from '~/app/store/notification.store';
import { AlarmCenterComponent } from '../alarm-center/alarm-center.component';
import { UserComponent } from '../user/user.component';

@Component({
  selector: 'gplus-header',
  imports: [
    UserComponent,
    TranslateModule,
    CwIcon,
    CommonModule,
    RouterModule,
    CwBadgeNotification,
    CwTooltip,
    IconCloudSyncComponent,
    IconCloudLoadingComponent,
    LocalizedDatePipe
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  public readonly headerService = inject(HeaderService);
  private readonly sidebarService = inject(SidebarService);
  public readonly ws = inject(WsEventsService);
  public readonly network = inject(NetworkService);
  public readonly statusService = inject(StatusService);
  public readonly jobStore = inject(TherapyJobStore);
  public readonly store = inject(NotificationsStore);

  // Public enum
  public status = Status;
  public connectionType = ConnectionType;
  public dateFormat = DateFormat;

  public openMobileMenuClicked() {
    this.headerService.setMobileMenuBtn(!this.headerService.toggleMobileMenu());
  }

  public alarmClicked() {
    this.sidebarService.open({
      open: false,
      id: SidebarIds.ALARM_CENTER,
      config: {
        title: 'AlarmCenterTitle',
        actionLabel: null,
        secondaryLabel: 'AlarmCenterCloseBtn'
      },
      component: AlarmCenterComponent
    });
  }
}
